module.exports = __webpack_public_path__ + "static/media/spot1.5e313f54.png";